export const destroy = async (id, target) => {
    await target.$confirm('Bạn có chắc chắn câu hỏi này?', 'Xóa hỏi đáp', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'error'
    }).then(async res => {
        let returnID = '';
        if(!Array.isArray(id)){
            returnID = id;
        }else{
            id.map((item, index) => {
                if(index == 0){
                    returnID += item.toString();
                }else{
                    returnID += ','+item;
                }
            })
        }
        await apiDelete('/v2/profile/hoidap/'+returnID).then(res => {
            let data = res.data;
            if(data.status === 1){
                target.$message({
                    message: data.message,
                    type: 'success',
                    center: true,
                });
                target.$eventBus.$emit('call-hd-current-page', true)
            }else{
                target.$message({
                    message: data.message,
                    type: 'warning',
                    center: true,
                });
            }
        });
    }).catch(() => {})
}

export const notAction = () => {
    Vue.prototype.$confirm('Sau 48h đăng câu hỏi bạn không được quyền sửa, xóa câu hỏi!', 'Thông báo', {
        confirmButtonText: 'Đã hiểu',
        cancelButtonText: 'Thoát',
        type: 'warning'
    }).then(() => {}).catch(() => {});
} 